export default __webpack_public_path__ + "05129d906a00cdccf8c55265f64f4525.png";